/**
 * @generated SignedSource<<b5486777723131a43c12646f80c79252>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FormEntrySearchFieldsEnum = "CompanyName" | "Country" | "Created" | "Email" | "ExtraData" | "FirstName" | "FormId" | "FormTitle" | "Id" | "JobTitle" | "LastName" | "MarketingConsent" | "Message" | "Modified" | "PhoneNumber" | "VisitorId";
export type OrderEnum = "ASC" | "DESC";
export type PostObjectsConnectionDateColumnEnum = "DATE" | "MODIFIED";
export type RelationEnum = "AND" | "OR";
export type RootQueryToFormEntryConnectionWhereArgs = {
  companyName?: string | null | undefined;
  country?: string | null | undefined;
  createdDateQuery?: DateQueryInput | null | undefined;
  email?: string | null | undefined;
  firstName?: string | null | undefined;
  formId?: string | null | undefined;
  formIdIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  formIdNotIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  formTitle?: string | null | undefined;
  id?: string | null | undefined;
  idIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  idNotIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  jobTitle?: string | null | undefined;
  lastName?: string | null | undefined;
  marketingConsent?: boolean | null | undefined;
  message?: string | null | undefined;
  modifiedDateQuery?: DateQueryInput | null | undefined;
  order?: OrderEnum | null | undefined;
  orderBy?: ReadonlyArray<FormEntrySearchFieldsEnum | null | undefined> | null | undefined;
  phoneNumber?: string | null | undefined;
  search?: string | null | undefined;
  searchFields?: ReadonlyArray<FormEntrySearchFieldsEnum | null | undefined> | null | undefined;
  visitorId?: string | null | undefined;
};
export type DateQueryInput = {
  after?: DateInput | null | undefined;
  before?: DateInput | null | undefined;
  column?: PostObjectsConnectionDateColumnEnum | null | undefined;
  compare?: string | null | undefined;
  day?: number | null | undefined;
  hour?: number | null | undefined;
  inclusive?: boolean | null | undefined;
  minute?: number | null | undefined;
  month?: number | null | undefined;
  relation?: RelationEnum | null | undefined;
  second?: number | null | undefined;
  week?: number | null | undefined;
  year?: number | null | undefined;
};
export type DateInput = {
  day?: number | null | undefined;
  month?: number | null | undefined;
  year?: number | null | undefined;
};
export type FormEntry_Pagination_Query$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  where?: RootQueryToFormEntryConnectionWhereArgs | null | undefined;
};
export type FormEntry_Pagination_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FormEntry_Pagination_Fragment">;
};
export type FormEntry_Pagination_Query = {
  response: FormEntry_Pagination_Query$data;
  variables: FormEntry_Pagination_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FormEntry_Pagination_Query",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "FormEntry_Pagination_Fragment"
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FormEntry_Pagination_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RootQueryToFormEntryConnection",
        "kind": "LinkedField",
        "name": "formEntries",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RootQueryToFormEntryConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FormEntry",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "created",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "modified",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "formId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "where",
                        "value": {
                          "statusIn": [
                            "PUBLISH",
                            "TRASH"
                          ]
                        }
                      }
                    ],
                    "concreteType": "FormEntryToFormConnectionEdge",
                    "kind": "LinkedField",
                    "name": "form",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Form",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "form(where:{\"statusIn\":[\"PUBLISH\",\"TRASH\"]})"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "message",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phoneNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "companyName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "visitorId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "marketingConsent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RootQueryToFormEntryConnectionPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "where"
        ],
        "handle": "connection",
        "key": "FormEntry_Pagination_formEntries",
        "kind": "LinkedHandle",
        "name": "formEntries"
      }
    ]
  },
  "params": {
    "cacheID": "415fa5864741b7301c24f8228aa49dc7",
    "id": null,
    "metadata": {},
    "name": "FormEntry_Pagination_Query",
    "operationKind": "query",
    "text": "query FormEntry_Pagination_Query(\n  $after: String\n  $first: Int\n  $where: RootQueryToFormEntryConnectionWhereArgs\n) {\n  ...FormEntry_Pagination_Fragment_3sueo6\n}\n\nfragment FormEntry_Pagination_Fragment_3sueo6 on RootQuery {\n  formEntries(after: $after, first: $first, where: $where) {\n    count\n    edges {\n      node {\n        id\n        created\n        modified\n        formId\n        form(where: {statusIn: [PUBLISH, TRASH]}) {\n          node {\n            title\n            id\n          }\n        }\n        email\n        firstName\n        lastName\n        message\n        phoneNumber\n        companyName\n        jobTitle\n        visitorId\n        marketingConsent\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d000ea53731133a106ca5de20501b9e1";

export default node;
